import { InterceptedCoroutine142wh200e9wbr as InterceptedCoroutine } from './InterceptedCoroutine.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../js/void.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../hacks.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from './intrinsics/Intrinsics.mjs';
import {
  Result__exceptionOrNull_impl_p6xea93txwfmg154xda as Result__exceptionOrNull_impl_p6xea9,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  Result3t1vadv16kmzk as Result,
  Companion_instancejy2056q2ma5w as Companion_instance,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../Result.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../Unit.mjs';
import { Continuation1aa2oekvx7jm7 as Continuation } from './Continuation.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../js/metadataUtils.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var GeneratorCoroutineImplClass;
function GeneratorCoroutineImpl() {
  if (GeneratorCoroutineImplClass === VOID) {
    class $ extends InterceptedCoroutine() {
      constructor(resultContinuation) {
        super();
        this.uc_1 = resultContinuation;
        var tmp = this;
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.vc_1 = VOID;
        var tmp_0 = this;
        var tmp0_safe_receiver = this.uc_1;
        tmp_0.wc_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.qc();
      }
      qc() {
        return ensureNotNull(this.wc_1);
      }
      xc(result) {
        var suspended = get_COROUTINE_SUSPENDED();
        var e = Result__exceptionOrNull_impl_p6xea9(result);
        var stepResult = e == null ? this.vc_1.next(_Result___get_value__impl__bjfvqg(result)) : this.vc_1.throw(e);
        var done = stepResult.done;
        var value = stepResult.value;
        $l$loop_0: while (!done) {
          try {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            value = value();
          } catch ($p) {
            var e_0 = $p;
            var nextStep = this.vc_1.throw(e_0);
            value = nextStep.value;
            done = nextStep.done;
            continue $l$loop_0;
          }
          if (value === suspended)
            break $l$loop_0;
          var nextStep_0 = this.vc_1.next(value);
          value = nextStep_0.value;
          done = nextStep_0.done;
        }
        return value;
      }
      yc(result, $super) {
        result = result === VOID ? _Result___init__impl__xyqfz8(null) : result;
        return $super === VOID ? this.xc(result) : $super.xc.call(this, new (Result())(result));
      }
      rc(result) {
        var exception = null;
        var tmp;
        try {
          tmp = this.xc(result);
        } catch ($p) {
          var tmp_0;
          if ($p instanceof Error) {
            var e = $p;
            exception = e;
            tmp_0 = null;
          } else {
            throw $p;
          }
          tmp = tmp_0;
        }
        var nextResult = tmp;
        if (nextResult === get_COROUTINE_SUSPENDED())
          return Unit_instance;
        this.ad();
        var tmp0_safe_receiver = this.uc_1;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.run' call
          if (!(exception == null)) {
            // Inline function 'kotlin.coroutines.resumeWithException' call
            // Inline function 'kotlin.Companion.failure' call
            var exception_0 = exception;
            var tmp$ret$3 = _Result___init__impl__xyqfz8(createFailure(exception_0));
            tmp0_safe_receiver.sc(tmp$ret$3);
          } else {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$5 = _Result___init__impl__xyqfz8(nextResult);
            tmp0_safe_receiver.sc(tmp$ret$5);
          }
        }
      }
      sc(result) {
        return this.rc(result);
      }
    }
    initMetadataForClass($, 'GeneratorCoroutineImpl', VOID, VOID, [Continuation()]);
    GeneratorCoroutineImplClass = $;
  }
  return GeneratorCoroutineImplClass;
}
//region block: exports
export {
  GeneratorCoroutineImpl as GeneratorCoroutineImpl2pzxhv55we2g3,
};
//endregion

//# sourceMappingURL=GeneratorCoroutineImpl.mjs.map
